import React, {useContext} from "react";
import './Intro.css'
import Github from '../../assets/github.png';
import Lnk from '../../assets/lnk.png';
import FloatingDiv from "../floatingDiv/FloatingDiv";
import tresdmodeling from '../../assets/tresdmodeling.png';
import lampara from '../../assets/lampara.png';
import pincel from '../../assets/pincel.png';
import mancha from '../../assets/mancha.png';
import code from '../../assets/code.png';
import profile from '../../assets/profile4.png';
import { themeContext } from "../../Context";
import {motion} from 'framer-motion';
import { useTranslation } from "react-i18next"; //translator




const Intro = () =>{

  const [t] = useTranslation("global");

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

    return(
        <div className="intro" id="Intro">
            <div className="i-left">
                <div className="i-name">
                    <span style={{color : darkMode? 'white' : ''}}> {t("Intro.hello")} </span>
                    <motion.span
                      initial={{ opacity:0.3 ,x: -60}}
                      whileInView={{opacity:1, x: 1 }}
                      transition={{ default:{ duration: 2, ease: [0, 0.71, 0.2, 1.01]} }}
                    > Sol Olmos</motion.span>
                    <span style={{color : darkMode? 'white' : ''}}> {t("Intro.occupation")}</span>
                    <span style={{color : darkMode? '#ffcd6a' : ''}}> {t("Intro.description")}
                    </span>
                </div>

                {/* <button className= " button i-button">Hire me!</button> */}
                <div 
                className="i-icons">
                    <a 
                     target="_blank"
                     rel="noreferrer" 
                     href="https://www.linkedin.com/in/sol-olmos-fullstackdev-industrialdesigner/">
                     <motion.img
                      whileHover={{ scale: 1.2, rotate: 15 }}
                      whileTap={{
                        scale: 0.8,
                        rotate: -15,
                        
                      }} 
                     className="img" src={Lnk} alt="icon" />
                    </a>

                    <a 
                     target="_blank"
                     rel="noreferrer" 
                     href="https://github.com/sololmos">
                     <motion.img
                      whileHover={{ scale: 1.2, rotate: 15 }}
                      whileTap={{
                        scale: 0.8,
                        rotate: -90,
                        
                      }} 
                      className="img" src={Github} alt="icon" />
                    </a>  
                    
                </div>


            </div>
            
{/* --------------- RIGHT SIDE------------------------- */}
            <div className="i-right">
             
               
                <motion.img
                 initial={{ scale: 0.2 }}
                 whileInView={{ scale: 0.9 }}
                 transition={{
                   default: { duration: 5, ease: [0, 0.71, 0.2, 1.01]},
                   scale: {type: "spring", damping: 5, stiffness: 100, restDelta: 0.001}
                 }}
                 className="foto"  src={mancha} alt="foto" style={{width : '490px', height : '510px', rotate:'120deg'}} />

                <img className="profile"  src={profile} alt="foto" style={{width : '315px', height : '500px'}}  />

                <motion.img
                  initial={{ opacity: 0, scale: 0.2 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{
                    default: { duration: 5, ease: [0, 0.71, 0.2, 1.01]},
                    scale: {type: "spring", damping: 5, stiffness: 100, restDelta: 0.001}
                  }}
                 className="foto" src={lampara} alt="foto" style={{width : '110px', height : '110px'}} 
                /> 

                <motion.img
                 initial={{ opacity: 0, scale: 0.2 }}
                 whileInView={{ opacity: 1, scale: 0.9 }}
                 transition={{
                   default: { duration: 5, ease: [0, 0.71, 0.2, 1.01]},
                   scale: {type: "spring", damping: 5, stiffness: 100, restDelta: 0.001}
                 }}
                 className="foto" src={code} alt="foto" style={{width : '100px', height : '100px'}}
                />

                <motion.img
                 initial={{ opacity: 0, scale: 0.2 }}
                 whileInView={{ opacity: 1, scale: 0.9 }}
                 transition={{
                   default: { duration: 5, ease: [0, 0.71, 0.2, 1.01]},
                   scale: {type: "spring", damping: 5, stiffness: 100, restDelta: 0.001}
                 }}
                 className="foto" src={pincel} alt="foto" style={{width : '100px', height : '100px'}} 
                 />

                <motion.img
                 initial={{ opacity: 0, scale: 0.2 }}
                 whileInView={{ opacity: 1, scale: 0.9 }}
                 transition={{
                   default: { duration: 5, ease: [0, 0.71, 0.2, 1.01]},
                   scale: {type: "spring", damping: 5, stiffness: 100, restDelta: 0.001}
                 }}
                 className="foto" src={tresdmodeling} alt="foto" style={{width : '110px', height : '100px'}} 
                 />

               {/*  -------------floatingdivs */}
                <motion.div className="floating-div di"
                 drag
                 dragConstraints={{ top: -50, left: -50, right: 50, bottom: 50,}}
                 style={{top : '15%', left : '82%'}}>
                  <FloatingDiv  text1={t("Intro.floatdiv1.t1")} text2={t("Intro.floatdiv1.t2")} />
                </motion.div>

                <motion.div className="floating-div gd"
                 drag
                 dragConstraints={{ top: -50, left: -50, right: 50, bottom: 50,}}
                 style={{top : '58%', left : '86%'}}>
                    <FloatingDiv  text1={t("Intro.floatdiv2.t1")} text2={t("Intro.floatdiv2.t2")} />
                </motion.div>

                <motion.div className="floating-div wd"
                 drag
                 dragConstraints={{ top: -50, left: -50, right: 50, bottom: 50,}}
                 style={{top : '62%', left : '5%'}}>
                    <FloatingDiv  text1={t("Intro.floatdiv3.t1")} text2={t("Intro.floatdiv3.t2")} />
                </motion.div>


                 {/* blur div -----------*/}
                <div
                 className="blur" style={{backgroundColor: "rgb(238 210 255)"}} ></div>
                <div className="blur"
                    style={{
                        background: "#C1F5FF",
                        top: "17rem",
                        width: "21rem",
                        height: "11rem",
                        left: "-10rem",
                    }}
                    ></div>

                  <div className="blur"
                    style={{
                        background: "var(--yellow)",
                        top: "17rem",
                        width: "21rem",
                        height: "11rem",
                        left: "15rem",
                    }}
                    ></div>    


            </div>

        </div>
    )
}

export default Intro